import React, { createContext, ReactNode, useContext, useState } from 'react';

import AlertV2 from '@/components/v2/Alert/Alert';

export interface AlertOptions {
  confirmText?: string;
  confirmAction?: () => void;
  subTitle?: ReactNode;
  extraText?: ReactNode;
  allowOutsideClickClose?: boolean;
  allowEscClose?: boolean;
  bottomComponent?: ReactNode;
  backgroundClassName?: string;
  bgClassName?: string;
  titleClassName?: string;
  subTitleClassName?: string;
  confirmWrapperClassName?: string;
  confirmButtonClassName?: string;
}

export interface AlertContextType {
  showAlert: (text: ReactNode, alertOptions?: AlertOptions) => void;
  hideAlert: () => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const useAlertContext = () => {
  const context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error('useAlert must be used within a AlertProvider');
  }
  return context;
};

export const AlertProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [alertContent, setAlertContent] = useState<ReactNode>('');
  const [alertOptions, setAlertOptions] = useState<AlertOptions>({});

  const showAlert = (text: ReactNode, alertOptions?: AlertOptions) => {
    setAlertContent(text);
    setIsVisible(true);
    if (alertOptions) {
      setAlertOptions(alertOptions);
    }
  };

  const hideAlert = () => {
    setIsVisible(false);
    setAlertOptions({});
  };

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert }}>
      {children}

      <AlertV2 isOpen={isVisible} close={hideAlert} title={alertContent} {...alertOptions} />
    </AlertContext.Provider>
  );
};
